(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/printable-coupon/assets/javascripts/printable-coupon-1x2.js') >= 0) return;  svs.modules.push('/components/pool-betting/printable-coupon/assets/javascripts/printable-coupon-1x2.js');
"use strict";


const PrintableCouponRow1x2 = svs.components.poolBetting.printableCouponRow.PrintableCouponRow1x2;
const clx = svs.components.lbUtils.clx;
const PrintableCouponHeader = () => React.createElement("div", {
  className: "pb_print_coupon__header"
}, React.createElement("div", null), React.createElement("div", {
  className: "pb_print_coupon__header__participants"
}, "Deltagare"), React.createElement("div", {
  className: "pb_print_coupon__header__match_start"
}, "Matchstart"), React.createElement("div", null));
const PrintableCoupon1x2 = _ref => {
  let draw = _ref.draw,
    _ref$participants = _ref.participants,
    participants = _ref$participants === void 0 ? [] : _ref$participants,
    _ref$signs = _ref.signs,
    signs = _ref$signs === void 0 ? [] : _ref$signs,
    _ref$uSigns = _ref.uSigns,
    uSigns = _ref$uSigns === void 0 ? [] : _ref$uSigns,
    _ref$mSigns = _ref.mSigns,
    mSigns = _ref$mSigns === void 0 ? [] : _ref$mSigns;
  const hasMSignInSomeEvent = mSigns.some(isMSign => isMSign);
  return React.createElement("div", {
    className: clx('pb_print_coupon pb_print_coupon__1x2', {
      ["pb_print_coupon__1x2--has_some_m_sign "]: hasMSignInSomeEvent
    })
  }, React.createElement(PrintableCouponHeader, null), draw === null || draw === void 0 ? void 0 : draw.drawEvents.map((drawEvent, index) => React.createElement(PrintableCouponRow1x2, {
    drawEvent: drawEvent,
    hasMSign: mSigns === null || mSigns === void 0 ? void 0 : mSigns[index],
    key: drawEvent.eventNumber,
    participants: participants === null || participants === void 0 ? void 0 : participants[index],
    signs: signs === null || signs === void 0 ? void 0 : signs[index],
    uSign: uSigns === null || uSigns === void 0 ? void 0 : uSigns[index]
  })));
};
setGlobal('svs.components.poolBetting.printableCoupon.PrintableCoupon1x2', PrintableCoupon1x2);

 })(window);